// extracted by mini-css-extract-plugin
export var head = "header-module--head--wNRnj";